import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Inicio from "./pages/inicio";       // Página principal
import Nosotros from "./pages/nosotros";      // Nueva página About (o About.jsx)
import Convenios from "./pages/convenios"; // Nueva pag convenios
import Eventos from "./pages/eventos";
import DashboardSecretaria from "./pages/secretaria/principal";
import Login from "./pages/LoginSecretaria";
import GestionSocios from "./pages/secretaria/GestionSocios";
import GestionCuotas from "./pages/secretaria/GestionCuotas";
import GestionConvenios  from "./pages/secretaria/GestionConvenios";
import DashboardSocio from "./pages/socios/DashboardSocio";
import VerCuotas from "./pages/socios/VerCuotas";
import GestionEspacios from "./pages/secretaria/reservas"; 
import ReservasSocios from "./pages/socios/reservassocios";
import  Registro from "./pages/registro";
import MisReservas from "./pages/socios/misReservas";
import GestionReservas from "./pages/secretaria/GestionReservas";
import RecuperarClave from "./pages/recuperarclave";
import GestionEventos from "./pages/secretaria/GestionEventos";
import VerificacionUtm from "./pages/secretaria/verificacionexel";
import Perfil from "./pages/socios/perfil";
import SerSocio from "./pages/SerSocio";
import AdminCuotas from "./pages/secretaria/adminCuotas";
import AdminFacultades from "./pages/secretaria/AdminFacultades";
import ReservarEspacio from "./pages/secretaria/reservarAdmin";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Inicio />} />
         <Route path="/perfil" element={<Perfil />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/convenios" element={<Convenios />} />
        <Route path="/eventos" element={<Eventos />} />
        <Route path="/GestionSocios" element={<GestionSocios />} />  
      
        <Route path="/DashboardSecretaria" element={< DashboardSecretaria />} />
        <Route path="/DashboardSocio" element={< DashboardSocio />} />
        <Route path="/registro" element={<Registro />} />
          <Route path="/recuperarclave" element={<RecuperarClave />} />
        <Route path="/GestionConvenios" element={< GestionConvenios />} />
         <Route path="/vercuotas" element={< VerCuotas />} />
         <Route path="/GestionEspacios" element={<GestionEspacios/>} />
           <Route path="/reservasSocios" element={<ReservasSocios/>} />
             <Route path="/MisReservas" element={<MisReservas/>} />
            <Route path="/reservas" element={<GestionReservas/>} />
             <Route path="/GestionEventos" element={<GestionEventos/>} />
                 <Route path="/reportes" element={<VerificacionUtm/>} />
                 <Route path="/SerSocio" element={<SerSocio />} />
         <Route path="/AdminCuotas" element={<AdminCuotas/>} />    
         <Route path="/Facultades" element={<AdminFacultades/>} />     
           <Route path="/ReservarEspacio" element={<ReservarEspacio/>} />    
          
        <Route
          path="/GestionCuotas"
          element={<GestionCuotas />}
        />
        <Route path="/login" element={<Login />} />
         


        {/* Puedes agregar más rutas aquí en el futuro */}
      </Routes>
    </Router>
  );
}

export default App;
